import { pagination_params } from '../../shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';

  let path = pagination_params(params);

  params.CodigoCilindroTipo &&
    (path = `${path ? `${path}&` : ''}CodigoCilindroTipo=${params.CodigoCilindroTipo}`);

  return path;
};
